export const KPI_AREAS = [
  'B2B - Performance',
  'B2C - Performance',
  'Compliance & Quality',
  'Training',
  'Renewals / MAIA Actions',
  'Insurance and Services',
  'Marketing Activity',
  'Miscellaneous',
  'Package',
  'Campaign Deployment',
  'Used - Performance',
] as const

export type KpiArea = (typeof KPI_AREAS)[number]

export const KPI_AREA_OPTIONS = KPI_AREAS.map((area) => ({
  value: area,
  label: area,
}))
